import { schemas } from '@repo/contracts'
import { parseDataOfType } from '@/common/parseDataType'
import { apiErrorHandler } from '../errorHandler'
import type { z } from 'zod'

// Request/response schemas are generated Go-first from the backend handler
// annotations (see contracts/). Do not hand-edit; run `task contracts` after
// changing the Go structs. `.describe()` only labels parse-error messages.
export const CreateUpdateProjectRequestSchema =
  schemas.apihttp_CreateUpdateProjectRequest.describe('CreateUpdateProjectRequest')

export type CreateUpdateProjectRequest = z.infer<typeof CreateUpdateProjectRequestSchema>

const CreateProjectResponseSchema = schemas.apihttp_ProjectResponse.describe('CreateProjectResponse')

type CreateProjectResponse = z.infer<typeof CreateProjectResponseSchema>

export async function createProject(req: CreateUpdateProjectRequest): Promise<CreateProjectResponse> {
  const validatedReq = parseDataOfType(req, CreateUpdateProjectRequestSchema)
  const res = await fetch('/api/projects', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(validatedReq)
  })
  await apiErrorHandler(res)
  return parseDataOfType(await res.json(), CreateProjectResponseSchema)
}

export async function updateProject(projectId: number, req: CreateUpdateProjectRequest): Promise<void> {
  const validatedReq = parseDataOfType(req, CreateUpdateProjectRequestSchema)
  const res = await fetch(`/api/projects/${projectId}`, {
    method: 'PUT',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(validatedReq)
  })
  await apiErrorHandler(res)
}
